<template>
<!--header section start-->
<header class="header" style="background: #1bc5bd;">


    <!--start navbar-->
    <nav :class="'navbar navbar-expand-lg fixed-to bg-transparent ' + affix">
        <div class="container">
            <a class="navbar-brand" href="https://ventas.serpar.gob.pe">
                <img :src="'/static/logos/serpar-white.png'" width="auto" height="80" alt="logo">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="ti-menu d-none"><i class="el-icon-more"></i></span>
            </button>

            <div class="collapse navbar-collapse main-menu" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link class="nav-link page-scroll" :to="'/'">Inicio</router-link>
                    </li>
                    <li class="nav-item d-none">
                        <a class="nav-link page-scroll" href="#screenshots">Eventos</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link page-scroll dropdown-toggle" href="#" id="navbarDropdownPage" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Escuelas
                        </a>
                        <div class="dropdown-menu submenu" aria-labelledby="navbarDropdownPage">
                            <router-link :to="'/escuelas/virtuales'" class="dropdown-item">Virtuales</router-link>
                            <router-link :to="'/escuelas/presenciales'" class="dropdown-item">Presenciales</router-link>
                        </div>
                    </li>
                    <li class="nav-item">

                        <a href="https://m.me/LimaSerpar" target="_blank" class="nav-link page-scroll">Contactános</a>
                    </li>

                </ul>
            </div>
        </div>
    </nav>

    <!--end navbar-->
</header>
<!--header section end-->
</template>

<script>
export default {
    props: ['affix'],
}
</script>



// WEBPACK FOOTER //
// src/components/common/MainHeader.vue